import React, { useState, useEffect, useRef } from 'react';
import styles from './Stats.module.css';

const stats = [
  { value: 6000, suffix: '+', label: 'Успешных сделок' },
  { value: 20, suffix: '', label: 'Лет опыта' },
  { value: 30, suffix: '+', label: 'Стран-партнёров' },
  { value: 98, suffix: '%', label: 'Довольных клиентов' }
];

function AnimatedNumber({ target, suffix, inView }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 2000;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 16);
    return () => clearInterval(timer);
  }, [inView, target]);

  return <>{count}{suffix}</>;
}

export default function Stats() {
  const [inView, setInView] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {stats.map((s, i) => (
            <div className={styles.item} key={i}>
              <div className={styles.value}>
                <AnimatedNumber target={s.value} suffix={s.suffix} inView={inView} />
              </div>
              <div className={styles.label}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
